module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_tochigi-22ed74742f8c793563c62b1064972f72.png";